import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "vendor/components/Grid/GridItem.jsx";
import GridContainer from "vendor/components/Grid/GridContainer.jsx";
import CustomTextField from "vendor/components/CustomTextField/CustomTextField.jsx"
import Button from "vendor/components/CustomButtons/Button.jsx";
import Card from "vendor/components/Card/Card.jsx";
import CardHeader from "vendor/components/Card/CardHeader.jsx";
import CardBody from "vendor/components/Card/CardBody.jsx";
import CardFooter from "vendor/components/Card/CardFooter.jsx";
import CustomPicker from "UI/CustomPicker/CustomPicker";

import { darkBlueColor } from "utils/Constants"
import { editGameWeek } from "Pages/GameWeeks/actions/gameWeeks"

import { connect } from 'react-redux';


class EditGameWeekForm extends React.Component {

    state = {
        id: 1,
        number: 1,
        start_date: null,
        end_date: null
    }

    componentWillMount() {
        this.setState({
            ...this.props.gameWeek
        })
    }

    numberChangeHandler = (event) => {
        this.setState({ number: event.target.value });
    }

    startDateChangedHandler = (date) => {
        const start_date = date.format("YYYY-MM-DD HH:mm");
        this.setState({ start_date: start_date });
    }

    endDateChangedHandler = (date) => {
        const end_date = date.format("YYYY-MM-DD HH:mm");
        this.setState({ end_date: end_date });
    }

    addRoundHandler = () => {
        this.props.editGameWeek({ ...this.state })
        this.props.onClose()
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <GridContainer className={classes.container}>
                    <Card className={classes.card}>
                        <CardHeader color="warning" className={classes.cardHeader}>
                            <h4 className={classes.cardTitle}>Add Game Week</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <CustomTextField
                                        inputType="number"
                                        labelText="Number"
                                        id="number"
                                        inputProps={{
                                            value: this.state.number,
                                            onChange: (event) => this.numberChangeHandler(event)
                                        }}

                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <CustomPicker
                                        labelName="Start"
                                        onChange={this.startDateChangedHandler}
                                        date={this.state.start_date}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <CustomPicker
                                        labelName="End"
                                        onChange={this.endDateChangedHandler}
                                        date={this.state.end_date}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            <Button
                                onClick={this.addRoundHandler}
                                color="success">
                                Edit
                            </Button>
                        </CardFooter>
                    </Card>
                </GridContainer>
            </div>
        );
    };

}

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitle: {
        color: darkBlueColor,
        fontWeight: "700",
        marginTop: "0px",
        minHeight: "auto",
        marginBottom: "3px",
        textDecoration: "none"
    },
    card: {
        alignItems: "center",
        justifyContent: "center",
        flexGrow: "0",
        flexBasis: "100%"
    },
    container: {
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
    },
    cardHeader: {
        width: "100%",
    },
    selectItem: {
        display: "flex",
        alignItems: "center",
    }
};

const mapDispatchToProps = dispatch => {
    return {
        editGameWeek: data => dispatch(editGameWeek(data))
    }
}


export default connect(null, mapDispatchToProps)(withStyles(styles)(EditGameWeekForm));
